
const caches = [
	{
		name: 'Users',
		options: {
			table: 'v_active_users',
			schema: 'users'
		}
	},
	{
		name: 'Networks',
		options: {
			table: 'network',
			schema: 'users'
		}
	},
	{
		name: 'AccessRoles',
		options: {
			table: 'v_access_roles',
			schema: 'users'
		}
	},
	{
		name: 'UserSettings',
		options: {
			table: 'user_setting_lookup',
			schema: 'users'
		}
	}

];

export default caches;
